import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { Moon } from 'lucide-react';
import { motion } from 'framer-motion';
interface HeroSectionProps {
  onCtaClick: () => void;
}
export function HeroSection({
  onCtaClick
}: HeroSectionProps) {
  return <section className="relative pt-16 pb-10 md:pt-48 md:pb-32 overflow-hidden px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-199">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-amber-900/20 blur-[120px] rounded-full pointer-events-none" data-id="element-200" />
      <FadeIn delay={0.1} data-id="element-201">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-500/10 text-amber-300 text-xs md:text-sm font-medium mb-4 md:mb-8 border border-amber-500/20 pt-[4px] pb-[4px]" data-id="element-202">
          <Moon className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-203" />
          <span className="text-[16px]" data-id="element-204">Protocolo Nocturno de 5 Minutos</span>
        </div>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-205">
        <h1 className="md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-3 md:mb-6 text-[36px]" data-id="element-206">
          Tu Cerebro No Tiene Botón de OFF <br className="hidden md:block" data-id="element-207" />
          <span className="text-amber-400" data-id="element-208">(Pero Este Protocolo Sí)</span>
        </h1>
      </FadeIn>

      <FadeIn delay={0.3} data-id="element-209">
        <p className="md:text-2xl text-stone-300 mb-5 md:mb-10 max-w-3xl mx-auto text-[18px]" data-id="element-210">
          Vacíe su ansiedad nocturna, silencie la rumiación y recupere su sueño
          sin meditaciones guiadas ni fármacos.
        </p>
      </FadeIn>

      <FadeIn delay={0.35} data-id="element-211">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 4,
        ease: 'easeInOut'
      }} className="mx-auto mb-6 md:mb-12 relative max-w-[200px] md:max-w-[400px] perspective-[1000px]" data-id="element-212">
          <motion.img whileHover={{
          rotateY: -5,
          rotateX: 5,
          scale: 1.02
        }} transition={{
          duration: 0.4
        }} src="https://cdn.magicpatterns.com/uploads/4e7Y8xZzsUzCFT6eNbfD2g/ChatGPT_Image_18_abr_2026,_17_52_08.png" alt="Mente en Blanco Ebook Cover" className="w-full h-auto rounded-md shadow-[0_20px_50px_-12px_rgba(217,119,6,0.3)] border border-stone-800/50" style={{
          transformStyle: 'preserve-3d'
        }} data-id="element-213" />
        </motion.div>
      </FadeIn>

      <Button size="lg" className="bg-amber-600 hover:bg-amber-700 text-white text-base md:text-lg px-6 md:px-8 py-4 md:py-6 h-auto rounded-full shadow-[0_0_40px_-10px_rgba(217,119,6,0.5)] transition-all hover:shadow-[0_0_60px_-15px_rgba(217,119,6,0.7)] hover:scale-105" onClick={onCtaClick} data-id="element-214">
        Descargar el Protocolo Ahora
      </Button>
    </section>;
}